
import { lopActions } from "./lopActions";

export const danhMucActionsWrapper = {
    lop: lopActions,
    
}